<script setup>
import FormButton from '@/components/Shared/Form/Button.vue';
import FormInput from '@/components/Shared/Form/Input/Index.vue';
import FormGroupCheckbox from '@/components/Shared/Form/GroupCheckbox/Index.vue';
import { useForm } from '@inertiajs/vue3';
import { computed } from 'vue';

const emit = defineEmits(['submitted', 'updated']);

const props = defineProps({
  teamMember: {
    type: Object,
    default: null,
  },
  permissions: {
    type: Array,
    required: true,
  },
});

const isNew = computed(() => props.teamMember === null);

const form = useForm({
  id: props.teamMember?.id,
  email: props.teamMember?.email || '',
  permissions: props.teamMember?.permissions || [],
});

const submitInvitation = () => {
  if (isNew.value) {
    invite();
  } else {
    update();
  }
};

const invite = () => {
  form.post(route('dashboard.account.teams.invite'), {
    onSuccess: () => {
      form.reset();
      emit('submitted');
    },
  });
};

const update = () => {
  form.patch(
    route('dashboard.account.teams.team-member.update', {
      teamMember: props.teamMember.id,
    }),
    {
      onSuccess: () => {
        form.reset();
        emit('updated');
      },
    },
  );
};
</script>

<template>
  <form role="form" @submit.prevent="submitInvitation">
    <form-input
      id="invite-email"
      name="email"
      type="email"
      v-model="form.email"
      container-class="form-group"
      :disabled="!isNew"
      :label-text="trans('common.email')"
      :error="form.errors.email"
    />

    <form-group-checkbox
      v-model="form.permissions"
      :options="permissions"
      :error="form.errors.permissions"
      :label="trans('dashboard.account.teams.invitations.permissions')"
      :columns="2"
    />

    <div class="form_row">
      <div class="flex">
        <form-button
          :value="trans('dashboard.account.teams.invitations.check_all')"
          button-class="button button_hollow"
          type="button"
          @click="form.permissions = permissions"
        />

        <form-button
          class="mx-2"
          :value="trans('dashboard.account.teams.invitations.uncheck_all')"
          button-class="button button_danger"
          type="button"
          @click="form.permissions = []"
        />
      </div>

      <form-button
        class="mx-2"
        :value="isNew ? trans('common.invite') : trans('common.update')"
        :processing="form.processing"
      />
    </div>
  </form>
</template>
